<template>
    <Table :data="data"
           style="width:100%"
           :columns="columns"
           ref="table"></Table>
</template>
<script>
export default ({
    name: 'storageInfoTable',
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            columns: [
                {
                    width: 250,
                    title: this.$i18n.t('名称/ID'),
                    render: (h, params) => {
                        const { ShareInfo } = params.row
                        const id = (ShareInfo && ShareInfo[0].FileSystemID) || '--'
                        const name = (ShareInfo && ShareInfo[0].DPCShareName.replace(/\//g, '')) || '--'
                        return h('div', {
                            style: {
                                'line-height': '1.75',
                                padding: '5px 0'
                            }
                        }, [
                            h('div', {
                                attrs: {
                                    title: name
                                },
                                style: {
                                    color: '#1f68b3',
                                    'white-space': 'nowrap',
                                    overflow: 'hidden',
                                    'text-overflow': 'ellipsis'
                                }
                            }, name),
                            h('div', {
                                attrs: {
                                    title: id
                                },
                                style: {
                                    'white-space': 'nowrap',
                                    overflow: 'hidden',
                                    'text-overflow': 'ellipsis'
                                }
                            }, id)
                        ])
                    }
                },
                {
                    width: 150,
                    title: this.$i18n.t('存储池名称'),
                    render: (h, params) => {
                        const { ShareType } = params.row
                        return h('span', {}, ShareType || '--')
                    }
                },
                {
                    width: 150,
                    title: this.$i18n.t('协议类型'),
                    render: (h, params) => {
                        const { ShareInfo } = params.row
                        const type = (ShareInfo && ShareInfo[0].ShareProto) || '--'
                        return h('span', {}, type)
                    }
                },
                {
                    minwidth: 150,
                    title: this.$i18n.t('容量（GB）'),
                    render: (h, params) => {
                        const { ShareInfo } = params.row
                        const size = (ShareInfo && ShareInfo[0].Size) || '--'
                        return h('span', {}, size)
                    }
                }
            ]
        }
    },
    watch: {
        // data: {
        //     handler (v) {
        //         console.log(v, '------------')
        //     },
        //     deep: true
        // }
    }
})
</script>
